import { Checkbox } from '@components/atoms/Checkbox/Checkbox';
import { useId } from 'react';
import { twMerge } from 'tailwind-merge';
import { ConsentLabel } from './ConsentLabel';
import { defaultNewsletterConsent, type NewsletterConsentContent } from './newsletterContent';

export interface NewsletterConsentProps {
  marketing: boolean;
  onMarketingChange: (checked: boolean) => void;
  content?: NewsletterConsentContent;
  idPrefix?: string;
  className?: string;
  showMarketing?: boolean;
  required?: boolean;
}

export const NewsletterConsent = ({
  marketing,
  onMarketingChange,
  content = defaultNewsletterConsent,
  idPrefix = 'newsletter',
  className,
  showMarketing = true,
  required = true,
}: NewsletterConsentProps) => {
  const prefix = `${idPrefix}-${useId()}`;
  const label = (copy: NewsletterConsentContent['newsletter']) => (
    <ConsentLabel summary={copy.summary} text={copy.text} />
  );
  return (
    <div className={twMerge('flex flex-col gap-6 text-sm', className)}>
      <Checkbox
        id={`${prefix}-consent`}
        label={label(content.newsletter)}
        checkboxProps={{ required, 'aria-label': content.newsletter.summary }}
        classProps={{ label: 'ml-2 text-sm text-foreground/70', root: 'items-start' }}
      />
      {showMarketing && (
        <Checkbox
          id={`${prefix}-marketing`}
          label={label(content.marketing)}
          checkboxProps={{
            checked: marketing,
            'aria-label': content.marketing.summary,
            onChange: (event) => onMarketingChange(event.target.checked),
          }}
          classProps={{ label: 'ml-2 text-sm text-foreground/70', root: 'items-start' }}
        />
      )}
      <div className="prose prose-sm text-foreground/70" dangerouslySetInnerHTML={{ __html: content.privacy }} />
    </div>
  );
};
